import { VApp } from 'vuetify/lib/components/VApp';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-draft-reminder": "" } },
    [
      _c(
        VBanner,
        {
          staticClass: "draft-reminder",
          class: { "draft-reminder_desktop b-container mb-5": !_vm.isMobile },
          attrs: { elevation: "24" },
          model: {
            value: _vm.isVisible,
            callback: function ($$v) {
              _vm.isVisible = $$v
            },
            expression: "isVisible",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-space-between",
              class: { "flex-column": _vm.isMobile },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex",
                  class: {
                    "align-center": !_vm.isMobile,
                    "pt-2": _vm.isMobile,
                  },
                },
                [
                  _vm.showLpuLogoPicture
                    ? _c("LpuLogoPicture", {
                        attrs: {
                          "img-class":
                            "draft-reminder__avatar draft-reminder__avatar_lpu",
                          files: _vm.lpuLogoFiles,
                          "fallback-src":
                            _vm.storageData.reviewObject.avatarUrl,
                          alt: _vm.storageData.reviewObject.name,
                        },
                      })
                    : _c("img", {
                        staticClass: "draft-reminder__avatar",
                        class: {
                          "draft-reminder__avatar_lpu":
                            !_vm.isReviewObjectDoctor,
                        },
                        attrs: {
                          alt: _vm.storageData.reviewObject.name,
                          src: _vm.storageData.reviewObject.avatarUrl,
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "draft-reminder_text text-body-2",
                      class: {
                        "ml-4": _vm.isMobile,
                        "ml-6": !_vm.isMobile,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("У вас остался незавершённый отзыв о", {
                              ns: _vm.$i18next.language,
                            })
                          ) +
                          " " +
                          _vm._s(_vm.reviewObjectTypeText) +
                          "\n          "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "text-subtitle-2",
                          class: { "text-no-wrap": _vm.isReviewObjectDoctor },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.reviewObjectNameText) +
                              _vm._s(!_vm.isMobile ? "." : "") +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isMobile ? _c("br") : _vm._e(),
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Хотите дописать его и поделиться мнением с пациентами",
                            { ns: _vm.$i18next.language }
                          )
                        ) + "?\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center justify-end" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "px-2",
                      attrs: { text: "", color: "text" },
                      on: { click: _vm.handleClickNotNow },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("Не сейчас", { ns: _vm.$i18next.language })
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "px-2 ml-2",
                      class: { "mr-2": !_vm.isMobile },
                      attrs: {
                        text: "",
                        color: "primary",
                        href: _vm.newRateUrl,
                      },
                      on: { click: _vm.handleClickGoToReview },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("К отзыву", { ns: _vm.$i18next.language })
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }